const defaultHeaderProps = {
  fontWeight: 900,
  fontFamily: 'PoppinsLight, PoppinsBold, sans-serif'
};

export const typography = {
  h1: {
    ...defaultHeaderProps,
    fontSize: 36,
    letterSpacing: '-0.24px'
  },
  h2: {
    ...defaultHeaderProps,
    fontSize: 28,
    letterSpacing: '-0.24px'
  },
  h3: {
    ...defaultHeaderProps,
    fontSize: 24,
    letterSpacing: '-0.06px'
  },
  h4: {
    ...defaultHeaderProps,
    fontSize: 20,
    letterSpacing: '-0.06px'
  },
  h5: {
    ...defaultHeaderProps,
    fontSize: 16
  },
  h6: {
    ...defaultHeaderProps,
    fontSize: 14,
    letterSpacing: '-0.05px'
  },
  overline: {
    fontWeight: 500
  },
  fontFamily: 'PoppinsLight, PoppinsBold, sans-serif'
};
